import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user_account",
  "use": "icon-user_account-usage",
  "viewBox": "0 0 31 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 31 31\" id=\"icon-user_account\"><g><g></g><g><ellipse cx=\"15.5\" cy=\"10.5\" rx=\"6.75\" ry=\"6.75\" fill-opacity=\"0\" stroke-opacity=\"1\" stroke=\"currentColor\" fill=\"none\" stroke-width=\"1.5\" /></g><g><rect x=\"3.75\" y=\"20.75\" width=\"23.5\" height=\"6.5\" rx=\"3.25\" fill-opacity=\"0\" stroke-opacity=\"1\" stroke=\"currentColor\" fill=\"none\" stroke-width=\"1.5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user_account.svg
// module id = CLpQ
// module chunks = 102